import React, { FC } from 'react'
import { classNames, format } from '@dt/fe-utils'

interface IProps {
  selected?: boolean;
  amount: number;
  onChange: (e) => void;
}

const AlipaySimpleItem: FC<IProps> = ({ selected, amount, onChange }) => {
  const handleChange = (e) => {
    onChange(e)
  }

  return (
    <div
      className={classNames('external-pay-method-item', 'alipay--app', { selected })}
      data-cypid='alipaySimpleItem'
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-zhifubaozhifu'></i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          <div className='name'>{i18n.t('pay.alipay')}</div>
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default AlipaySimpleItem
